<ng-container *ngrxLet="disabled | dynamicOperationIf as disable">
  @if (disable) {
  <a
    class="cursor-not-allowed"
    (click)="isStopPropagation ? $event.stopPropagation() : null"
  >
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </a>
  } @else { @if (!hrefUrl) {
  <a
    [routerLink]="routerLink"
    [queryParams]="params"
    [queryParamsHandling]="paramsHandling"
    (click)="
      disable ? $event.preventDefault() : null;
      isStopPropagation ? $event.stopPropagation() : null
    "
  >
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </a>
  } @else {
  <a
    [href]="hrefUrl"
    [target]="target"
    (click)="isStopPropagation ? $event.stopPropagation() : null"
  >
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </a>
  } }
</ng-container>

<ng-template #contentTemplate>
  @if (linkText) {
  {{ linkText }}
  } @else {
  <ng-content></ng-content>
  }
</ng-template>
